import React, { useEffect } from 'react';
import FeaturesSelection from './FeaturesSelection/FeaturesSelection';
import ReleasesSelection from './ReleasesSelection/ReleasesSelection';

import './ModelSelection.scss'
import { MODEL_SELECTION_SELECTED_RELEASE } from '../../../shared/const/Routes/statePaths';
import { getSafe } from '../../../shared/utility';
import { useSelector } from 'react-redux';

const ModelSelection = props => {

  const {selectedSubProject, setNextDisabled, filters, setFilters} = props;
  const selectedRow = useSelector((state) => getSafe(MODEL_SELECTION_SELECTED_RELEASE ,state));

  useEffect(() => {
    setNextDisabled(true);
  }, []);

  useEffect(() => {
    if (selectedRow == null) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [selectedRow]);

  return (
    <div className='flex-column height-100 overflow-hidden'>
      <label className='project-sub-title model-selection-title'>
        {selectedSubProject?.projectName}
      </label>
      <div className='model-selection-content-wrapper'>
        <FeaturesSelection
          subProject={selectedSubProject.projectId}
          setFilters={setFilters}
        />
        <ReleasesSelection
          subProject={selectedSubProject.projectId}
          filters={filters}
        />
      </div>
    </div>
  );
};

export default ModelSelection;
